import axios from 'axios'
import { LIST_AUDIT_APP} from '../../api/apiRoute'

export const listAuditApp = async (data) => {
    return axios.post(LIST_AUDIT_APP, data).then(res => {
        if (res.status === 200) {
            return res.data
        } else {
            return {
                status: 'error',
                message: "La connexion à internet est instable !"
            }
        }
    }).catch(err => console.log(err))
}